<template>
  <div>
    <section id="servicios" class="secciones seccion-blanca">
      <div class="container">
        <SubSectionStandartHead :subSectionData="subSectionData" />
        <div class="row">
          <div
            class="col-sm-6 col-md-4 col-lg-3 text-center"
            v-for="(item, index) in itemList"
            :key="index"
          >
            <div class="servicios-home animacion">
              <a v-bind:href="item.button_url" target="_blank" class="servicios-home-foto">
                <img
                  class="imagen-cover"
                  v-bind:src="imgPreUrl + item.url_image + 'x320.jpg'"
                  alt="portada catálogo"
                />
              </a>
              <a
                v-bind:href="item.button_url"
                target="_blank"
                class="servicios-home-texto animacion"
                style="text-decoration: none;"
              >
                <h2>{{ item.title_item_es }}</h2>
              </a>
              <div class="servicios-home-boton animacion">
                <a
                  v-bind:href="item.button_url"
                  target="_blank"
                  class="btn-al btn-al-md btn-al-celeste-solid"
                  style="text-decoration: none;"
                  >{{ item.text_button_es }}</a
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <ul
            role="menubar"
            aria-disabled="false"
            aria-label="Pagination"
            class="pagination b-pagination pagination-sm center-page"
          >
            <template v-if="currentPage == 1">
              <li role="none presentation" class="page-item disabled">
                <a
                  role="menuitem"
                  tabindex="-1"
                  aria-label="Goto next page"
                  target="_self"
                  class="page-link"
                  ><span aria-hidden="true" class="page-selector">«</span></a
                >
              </li>
            </template>
            <template v-else>
              <li role="none presentation" class="page-item" @click="goToPage(1)">
                <a
                  role="menuitem"
                  tabindex="-1"
                  aria-label="Goto next page"
                  target="_self"
                  class="page-link"
                  ><span aria-hidden="true" class="page-selector">«</span></a
                >
              </li>
            </template>
            <template v-if="currentPage > 1">
              <li
                role="none presentation"
                class="page-item"
                aria-hidden="true"
                @click="goToPage(currentPage - 1)"
              >
                <span class="page-link page-selector">‹</span>
              </li>
            </template>
            <template v-else>
              <li role="none presentation" class="page-item disabled" aria-hidden="true">
                <span class="page-link page-selector">‹</span>
              </li>
            </template>
            <li
              v-for="page in pages"
              :key="page"
              role="none presentation"
              :class="['page-item', page === currentPage ? 'active' : '']"
              @click="goToPage(page)"
            >
              <a
                role="menuitemradio"
                tabindex="-1"
                aria-label="Goto page 2"
                aria-checked="false"
                aria-posinset="2"
                aria-setsize="4"
                target="_self"
                class="page-link page-selector"
                >{{ page }}</a
              >
            </li>
            <template v-if="currentPage == finalPage">
              <li role="none presentation" class="page-item disabled">
                <a
                  role="menuitem"
                  tabindex="-1"
                  aria-label="Goto next page"
                  target="_self"
                  class="page-link"
                  ><span aria-hidden="true" class="page-selector">›</span></a
                >
              </li>
            </template>
            <template v-else>
              <li role="none presentation" class="page-item" @click="goToPage(currentPage + 1)">
                <a
                  role="menuitem"
                  tabindex="-1"
                  aria-label="Goto next page"
                  target="_self"
                  class="page-link"
                  ><span aria-hidden="true" class="page-selector">›</span></a
                >
              </li>
            </template>
            <template v-if="currentPage == finalPage">
              <li role="none presentation" class="page-item disabled">
                <a
                  role="menuitem"
                  tabindex="-1"
                  aria-label="Goto next page"
                  target="_self"
                  class="page-link"
                  ><span class="page-selector" aria-hidden="true">»</span></a
                >
              </li>
            </template>
            <template v-else>
              <li role="none presentation" class="page-item" @click="goToPage(finalPage)">
                <a
                  role="menuitem"
                  tabindex="-1"
                  aria-label="Goto next page"
                  target="_self"
                  class="page-link"
                  ><span class="page-selector" aria-hidden="true">»</span></a
                >
              </li>
            </template>
          </ul>
        </div>
      </div>
    </section>
    <GoToTrackingModule />
    <GuideModule />
  </div>
</template>

<script>
import SubSectionStandartHead from '@/views/components/SubSectionStandartHead';
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import { getItemsxSubSectionxPage } from '@/service/sections.service';
import { config_settings } from '@/config.js';
import { NOT_FOUND } from '@/types/httpd.constants';

export default {
  components: {
    GoToTrackingModule,
    GuideModule,
    SubSectionStandartHead,
  },
  props: ['subSectionData'],
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      codSubSection: this.subSectionData.cod_sub_section,
      itemList: [],
      itemsPerPage: 8,
      pages: [],
      finalPage: 1,
      currentPage: 1,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    goToPage(page) {
      getItemsxSubSectionxPage(this.codSubSection, this.itemsPerPage, page)
        .then((response) => {
          var arreglo = response.data.items;
          if (arreglo.length == 0) {
            this.goToPage(page - 1);
          }
          this.itemList = arreglo;
          this.pages = response.data.visible_pages;
          this.finalPage = response.data.final_page;
          this.currentPage = page;
        })
        .catch((error) => {
          if (error.response.status === NOT_FOUND) {
            this.goToPage(page - 1);
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },
  },
  created() {
    this.scrollToTop();
    this.goToPage(1);
  },
};
</script>
